<div class="container">
  <mat-card>
    <form [formGroup]="reportForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap responsive-column">
          <mat-form-field class="flex-100">
            <mat-label>{{ 'labels.inputs.Report Name' | translate }}</mat-label>
            <input matInput required formControlName="reportName" />
            @if (reportForm.controls.reportName.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Report Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-50">
            <mat-label>{{ 'labels.inputs.Report Type' | translate }}</mat-label>
            <mat-select required formControlName="reportType">
              @for (allowedReportType of reportTemplateData.allowedReportTypes; track allowedReportType) {
                <mat-option [value]="allowedReportType">
                  {{ allowedReportType | translateKey: 'text' }}
                </mat-option>
              }
            </mat-select>
            @if (reportForm.controls.reportType.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Report Type' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-50">
            <mat-label>{{ 'labels.inputs.Report Sub Type' | translate }}</mat-label>
            <mat-select formControlName="reportSubType">
              @for (allowedReportSubType of reportTemplateData.allowedReportSubTypes; track allowedReportSubType) {
                <mat-option [value]="allowedReportSubType">
                  {{ allowedReportSubType | translateKey: 'text' }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="flex-50">
            <mat-label>{{ 'labels.inputs.Report Category' | translate }}</mat-label>
            <mat-select formControlName="reportCategory">
              @for (reportCategoryType of reportCategoryTypeOptions; track reportCategoryType) {
                <mat-option [value]="reportCategoryType">
                  {{ reportCategoryType | translateKey: 'catalogs' }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div class="user-report-wrapper flex-50">
            <mat-checkbox class="user-report" labelPosition="after" formControlName="useReport">
              {{ 'labels.inputs.User Report (UI)' | translate }}
            </mat-checkbox>
          </div>

          <mat-form-field class="flex-100">
            <mat-label>{{ 'labels.inputs.Description' | translate }}</mat-label>
            <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="2"></textarea>
          </mat-form-field>

          <mat-form-field class="flex-98">
            <mat-label>{{ 'labels.inputs.SQL' | translate }}</mat-label>
            <textarea
              matInput
              required
              formControlName="reportSql"
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
            ></textarea>
            @if (reportForm.controls.reportSql.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.SQL' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>

        <br />

        <div class="layout-row-wrap gap-60percent layout-lt-md-column">
          <p class="mat-title flex-20">{{ 'labels.inputs.Report Parameters' | translate }}</p>

          <button mat-raised-button class="flex-20" type="button" color="primary" (click)="addReportParameter()">
            <fa-icon icon="plus" class="m-r-10"></fa-icon>{{ 'labels.buttons.Add Report Parameter' | translate }}
          </button>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="parameterName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'labels.buttons.Parameters' | translate }}
            </th>
            <td mat-cell *matCellDef="let reportParameter">
              {{ reportParameter.parameterName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="parameterNamePassed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'labels.inputs.Parameter Name Passed to Pentaho' | translate }}
            </th>
            <td mat-cell *matCellDef="let reportParameter">
              {{ reportParameter.reportParameterName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'labels.inputs.Actions' | translate }}
            </th>
            <td mat-cell *matCellDef="let reportParameter">
              <div class="layout-row gap-15percent">
                <button
                  type="button"
                  class="flex-8"
                  color="primary"
                  mat-icon-button
                  (click)="editReportParameter(reportParameter)"
                >
                  <fa-icon icon="edit" size="lg"></fa-icon>
                </button>
                <button
                  type="button"
                  class="flex-8"
                  color="warn"
                  mat-icon-button
                  (click)="deleteReportParameter(reportParameter)"
                >
                  <fa-icon icon="trash" size="lg"></fa-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          type="submit"
          color="primary"
          [disabled]="!reportForm.valid && reportParametersData.length === 0"
          *LOSxHasPermission="'CREATE_REPORT'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
